// extracted by mini-css-extract-plugin
export default {"root__admin":"style-module__root__admin___IauaV","root__user":"style-module__root__user___YBfJ2","root__gallery":"style-module__root__gallery___Z9yWV","root__artist":"style-module__root__artist___aSWKH"};
    if(module.hot) {
      // 1697460472135
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  